import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackLetterRecipientAddedSpec,
  trackLetterRecipientRemovedSpec,
  trackLetterRecipientSearchedSpec,
  type LetterRecipientAdded,
  type LetterRecipientRemoved,
  type LetterRecipientSearched,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const letterEvents: SnowplowEventMap = {
  [TrackingEventName.LetterRecipientAdded]: (props) =>
    trackLetterRecipientAddedSpec(props as LetterRecipientAdded),
  [TrackingEventName.LetterRecipientRemoved]: (props) =>
    trackLetterRecipientRemovedSpec(props as LetterRecipientRemoved),
  [TrackingEventName.LetterRecipientSearched]: (props) =>
    trackLetterRecipientSearchedSpec(props as LetterRecipientSearched),
};
